import { Link } from "react-router-dom";
import { LucideIcon } from "lucide-react";
import { cn } from "@/utils/utils";
import { buttonVariants } from "@/components/ui/button-variants";
import Text from "@/components/ui/text";

export interface NavItemType {
  title: string;
  icon: LucideIcon | string;
  variant: "default" | "ghost";
  target: string;
}

interface NavItemProps {
  currentPageName?: string;
  onPageClick: (targetName: string) => void;
  item: NavItemType;
}

export function NavItem({
  currentPageName = "/",
  onPageClick,
  item
}: NavItemProps) {
  const linkToDataTestId = (link: string): string =>
    link === "/" ? "home" : `${link}-link`;
  const { target, title, icon: Icon } = item;

  return (
    <Link
      key={target}
      to={target}
      data-test={linkToDataTestId(target)}
      className={cn(
        buttonVariants({ size: "lg" }),
        "h-8 w-full dark:bg-surface-sidebar-navigation dark:text-secondary dark:hover:bg-surface-hover-soft dark:hover:text-primary font-normal",
        "justify-start",
        currentPageName === target &&
          "dark:bg-buttons-nav-item-selected dark:text-cta dark:hover:bg-buttons-nav-item-selected"
      )}
      onClick={() => {
        onPageClick(target);
      }}
    >
      <Icon
        className={cn(
          "mr-2 h-4 w-4 [&_*]:[vector-effect:non-scaling-stroke] [&_*]:[stroke-width:1.2px]",
          currentPageName === target && "dark:text-cta"
        )}
      />
      <Text
        as="span"
        variant="body"
        className={cn(
          "text-primary",
          currentPageName === target && "dark:text-cta"
        )}
      >
        {title}
      </Text>
    </Link>
  );
}
